import { render, staticRenderFns } from "./_base-signature-pad.vue?vue&type=template&id=cce558a0&"
import script from "./_base-signature-pad.vue?vue&type=script&lang=js&"
export * from "./_base-signature-pad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports